__turbopack_context__.v({
  "chips-container": "chip-module-scss-module__RPxXbq__chips-container",
  "chips-container-inline": "chip-module-scss-module__RPxXbq__chips-container-inline",
  "chips-title": "chip-module-scss-module__RPxXbq__chips-title",
});
